<template>
  <div :class="{'table-responsive': isResponsive}">
    <div class="row mb10">
      <div class="col-md-2 pull-left mt-xs-10">
        <form-group-select
          v-model="totalForPage"
          :options="[
            {text: '20', value: 20},
            {text: '50', value: 50},
            {text: '100', value: 100},
            {text: '500', value: 500},
            {text: '1000', value: 1000},
            {text: 'Todos', value: rowsLength}
          ]"
          name="totalForPage"
          data-vv-as="Total por página"
          placeholder="Selecione"
        />
      </div>
      <div class="col-md-2 pull-right mt-xs-10">
        <form-group-input v-model.lazy="filterText" name="pesquisa" placeholder="Pesquisa"/>
      </div>
    </div>
    <table class="table table-striped table-hover">
      <thead>
        <template>
          <slot name="th"></slot>
        </template>
      </thead>
      <tbody>
        <slot name="rows" :rows="resultsExibe"></slot>
        <tr v-if="!resultsExibe || resultsExibe.length == 0">
          <td colspan="10">Nenhum registro encontrado</td>
        </tr>
      </tbody>
    </table>
    <div class="row">
      <div class="col-xs-12">
        <div
          class="pull-left mt5 itens-page"
        >Mostrando de {{start}} até {{end}} de {{rowsLength}} registros</div>
        <VuePagination class="pull-right mt0" v-model="currentPage" :total="totalPages"/>
      </div>
    </div>
  </div>
</template>

<script>
import { slice } from "lodash";
import VuePagination from "vue-bs-pagination";
import Fuse from "fuse.js";

export default {
  name: "data-table",
  components: {
    VuePagination
  },
  props: {
    rows: {
      type: Array,
      default: []
    },
    isResponsive: {
      type: Boolean,
      default: true
    },
    keys: null
  },
  data() {
    return {
      totalForPage: "20",
      currentPage: 1,
      start: 0,
      end: 0,
      totalPages: 1,
      rowsLength: 0,
      resultsExibe: [],
      filterText: ""
    };
  },
  asyncComputed: {
    results() {
      if (this.rows) {
        if (this.filterText != "") {
          return new Promise((resolve, reject) => {
            let run = new Fuse(this.rows, {
              threshold: 0.3,
              keys: this.keys
            });
            let results = run.search(this.filterText);
            resolve(results);
          }).then(response => {
            return response;
          });
        }
        return this.rows;
      }
    }
  },
  methods: {
    totalPagesFilter(length) {
      let total = Math.ceil(length / parseInt(this.totalForPage)) || 1;
      if (total < this.currentPage) {
        this.currentPage = 1;
      }
      this.totalPages = total;
    },
    alterarPage() {
      this.start = (this.currentPage - 1) * this.totalForPage + 1;
      if (this.rowsLength === 0) {
        this.start = 0;
      }
      this.end = this.currentPage * this.totalForPage;
      if (this.end > this.rowsLength) {
        this.end = this.rowsLength;
      }
      this.resultsExibe = slice(this.results, this.start - 1, this.end);
    }
  },
  watch: {
    results(value) {
      this.resultsExibe = value;
      this.rowsLength = value && value.length > 0 ? value.length : 0;
      this.totalPagesFilter(this.rowsLength);

      this.alterarPage();
    },
    currentPage(value) {
      this.alterarPage();
    },
    totalForPage() {
      this.currentPage = 1;
      this.totalPagesFilter(this.rowsLength);
      this.alterarPage();
    }
  }
};
</script>

<style>
th {
  cursor: pointer;
}

.table .ckbox input[type="checkbox"]:checked + label:after {
  top: 3px;
  left: 1px;
}

@media (max-width: 767px) {
  .mt-xs-10 {
    margin-top: 10px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/UIComponents/Tables/DataTable.vue